import { FC, ReactNode } from "react";
// 方法
import { markSearchValue } from "../../SuperSelect/util";

interface OptionLabelProps {
  /** 类名 */
  className?: string;
  /** 标题 */
  label?: ReactNode;
  /** 需要标记的字符串 */
  searchValue?: string;
};

/** 选项标题 */
const OptionLabel: FC<OptionLabelProps> = props => {
  const { className, label, searchValue, } = props;
  const labelNode = markSearchValue(label, searchValue, false);
  if (!labelNode) return null;
  if (typeof labelNode === 'string') {
    return <span className={className} title={label as string} dangerouslySetInnerHTML={{ __html: labelNode }}>{}</span>;
  }
  return <span className={className}>{label}</span>;
};

export default OptionLabel;
